import React from "react";
import { v4 } from "uuid";
import { Link } from "react-router-dom";

export const PageHandler = (props) => {
  const openedPage = props.offset / props.limit + 1;
  const isOpened = openedPage === props.page;

  return (
    <li key={v4()}>
      <Link
        to={{
          pathname: props.pathname,
          query: {
            offset: props.limit * (props.page - 1),
            limit: props.limit,
            searchParam: props.searchParam,
          },
        }}
        className={isOpened ? "active-page" : ""}
      >
        {props.page}
      </Link>
    </li>
  );
};
